import React from 'react';
import PropTypes from 'prop-types';

ChoiceGroupRatingIcon.propTypes = {
  size: PropTypes.number,
};

ChoiceGroupRatingIcon.defaultProps = {
  size: 16,
};

function ChoiceGroupRatingIcon (props) {
  return (
    <svg
      enableBackground="new 0 0 2447.6 2452.5"
      viewBox="1 1 11 11"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      fill="currentColor"
      strokeWidth={0}
      width={props.size}
      height={props.size}
    >
      <g transform="matrix(1,0,0,1,0.000583005,2.3899)">
        <path d="M10.297,1.875L1.703,1.875C1.487,1.875 1.313,2.043 1.313,2.25L1.313,4.97C1.313,5.178 1.487,5.345 1.703,5.345L10.296,5.32C10.512,5.32 10.686,5.152 10.686,4.945L10.686,2.25C10.687,2.043 10.513,1.875 10.297,1.875ZM4.219,4.594L2.156,4.594L2.156,2.719L4.219,2.719L4.219,4.594ZM7.031,4.594L4.969,4.594L4.969,2.719L7.031,2.719L7.031,4.594ZM9.844,4.594L7.781,4.594L7.781,2.719L9.844,2.719L9.844,4.594Z" />
      </g>
    </svg>
  );
}

export default ChoiceGroupRatingIcon;
